import { BaseKey, useApiUrl, useCustomMutation } from '@refinedev/core';
import { useLocaleStore } from 'stores/localeStore';
import { getUserInfoFromCache } from 'utility/helper';

const hiddenCategoryClearWasStarted = (data: unknown) => {
  const body = data && typeof data === "object" && "data" in data
    ? (data as { data?: unknown }).data
    : data;
  if (body && typeof body === "object" && "started" in body) {
    return (body as { started?: boolean }).started !== false;
  }
  return true;
};

export const useMultiUpdateCategories = () => {
  const apiUrl = useApiUrl();
  const { mutate, isLoading } = useCustomMutation();
  const { locale } = useLocaleStore();
  const userInfo = getUserInfoFromCache();
  
  const multiAddCategories = (productIds: React.Key[], categoryIds: number[]) => {
    mutate({
      url: `${apiUrl}/actions/add-categories`,
      method: "post",
      successNotification: (data, values) => {
        return {
          message: "",
          description: "Kategorier har lagts till",
          type: "success",
        };
      },
      values: {
        ids: productIds,
        categoryIds: categoryIds
      },
      config: {
        headers: { Authorization: `Bearer ${userInfo.token}`}
      }
    });
  };

  const multiDeleteCategories = (productIds: React.Key[], categoryIds: number[]) => {
    mutate({
      url: `${apiUrl}/actions/delete-categories`,
      method: "post",
      successNotification: (data, values) => {
        return {
          message: "",
          description: "Kategorier har tagits bort",
          type: "success",
        };
      },
      values: {
        ids: productIds,
        categoryIds: categoryIds
      },
      config: {
        headers: { Authorization: `Bearer ${userInfo.token}`}
      }
    });
  };

  const clearHiddenCategories = (productIds: React.Key[], onStarted?: () => void) => {
    mutate(
      {
        url: `${apiUrl}/actions/clear-hidden-categories`,
        method: "post",
        successNotification: (data) => {
          if (!hiddenCategoryClearWasStarted(data)) {
            return {
              message: "",
              description: "Inga dolda kategorier för det valda språket",
              type: "success",
            };
          }
          return {
            message: "",
            description: "Rensning av dolda kategorier har startats",
            type: "success",
          };
        },
        values: {
          ids: productIds,
        },
        config: {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
            lang: locale,
          },
        },
      },
      {
        onSuccess: (data) => {
          if (hiddenCategoryClearWasStarted(data)) {
            onStarted?.();
          }
        },
      }
    );
  };

  return {
    multiAddCategories,
    multiDeleteCategories,
    clearHiddenCategories,
    isClearingHiddenCategories: isLoading,
  };
};


